import SpinnerLoading from "../common/SpinnerLoading";
import React, { ReactNode } from "react";
import { QUERY_STATUS } from "../../utils/constants/dashboard/dashboardModuleConstants";

import { SpinnerContainer } from "./styles";

const cssOverride = {
  border: "4px solid"
};

interface QueryLoaderWrapperProps {
  queryStatus: typeof QUERY_STATUS[keyof typeof QUERY_STATUS] | {
    hasUpdates?: number;
    noUpdates?: number;
  };
  skeletonComponent: React.ReactElement;
  children: React.ReactElement;
  spinnerConfig?: {
    height?: number;
    isCounter?: boolean;
  };
};

const QueryLoaderWrapper = ({ queryStatus, skeletonComponent, children, spinnerConfig = { height: 350 } }: QueryLoaderWrapperProps) => {
  const offset = spinnerConfig?.isCounter ? 0 : 15;
  const height = spinnerConfig?.height + offset;

  switch (queryStatus) {
    case QUERY_STATUS.loading: {
      return skeletonComponent;
    }
    case QUERY_STATUS.success: {
      return children;
    }
    case QUERY_STATUS.refeching: {
      return (
        <SpinnerContainer height={height}>
          <SpinnerLoading size={40} css={cssOverride} />
        </SpinnerContainer>
      );
    }
    default:
      return <></>;
  }
};

export default QueryLoaderWrapper;
